import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface FeatureSettings {
  barcode_scanner_enabled?: boolean;
  product_subscriptions_enabled?: boolean;
  booking_enabled?: boolean;
  ai_skin_consultant_enabled?: boolean;
  ai_skin_consultant_require_login?: boolean;
  ai_skin_consultant_rate_limit_seconds?: number;
  ai_skin_consultant_daily_limit?: number;
  social_proof_enabled?: boolean;
  social_proof_min_interval_seconds?: number;
  social_proof_max_interval_seconds?: number;
  social_proof_display_seconds?: number;
  social_proof_initial_delay_seconds?: number;
  recently_viewed_enabled?: boolean;
  paysera_enabled?: boolean;
  cash_on_delivery_enabled?: boolean;
  seasonal_effects_enabled?: boolean;
}

export const useFeatureSettings = () => {
  return useQuery({
    queryKey: ['feature-settings'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('settings')
        .select('value')
        .eq('key', 'features')
        .maybeSingle();
      
      if (error) throw error;
      
      return data?.value as FeatureSettings || { 
        barcode_scanner_enabled: false, 
        product_subscriptions_enabled: false,
        booking_enabled: false,
        ai_skin_consultant_enabled: false,
        ai_skin_consultant_require_login: true,
        ai_skin_consultant_rate_limit_seconds: 60,
        ai_skin_consultant_daily_limit: 5,
      };
    },
  });
};
